import { createMuiTheme } from '@material-ui/core/styles';
import { lighten } from 'polished';
import defaultTheme from './themeDefault';
import clone from 'clone';

const theme = clone(defaultTheme);

theme.palette.primary = {
  main: "#00a9ff",
  contrastText: "#fff"
};
theme.palette.secondary = {
  main: "#00d4d2",
  contrastText: "#fff"
};
theme.palette.primary1 = [
  theme.palette.primary.main,
  lighten(0.1, theme.palette.primary.main),
  lighten(0.2, theme.palette.primary.main),
  lighten(0.3, theme.palette.primary.main),
  lighten(0.4, theme.palette.primary.main)
];
theme.palette.primary2 = [
  theme.palette.secondary.main,
  lighten(0.1, theme.palette.secondary.main),
  lighten(0.2, theme.palette.secondary.main),
  lighten(0.3, theme.palette.secondary.main),
  lighten(0.4, theme.palette.secondary.main)
];

theme.palette.gradient = [
  `linear-gradient(45deg, ${theme.palette.secondary.main} 0%, ${theme.palette.primary.main} 100%)`
]

const MUITheme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: theme.palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      contrastText: theme.palette.primary.contrastText
    },
    secondary: {
      // light: will be calculated from palette.primary.main,
      main: theme.palette.secondary.main,
      // dark: will be calculated from palette.primary.main,
      contrastText: theme.palette.secondary.contrastText
    },
  },
  overrides: {
    MuiPickersToolbarButton: {
      toolbarBtn: {
        '&:first-child': {
          fontSize: '1.5rem',
          '&:after': {
            content: '""',
            border: 'solid rgba(255, 255, 255, 0.54)',
            borderWidth: '0 3px 3px 0',
            display: 'inline-block',
            padding: '3px',
            transform: 'rotate(45deg)',
            position: 'relative',
            top: '-6px',
            right: '-10px',
          },
        },
      },
      toolbarBtnSelected: {
        '&:first-child': {
          '&:after': {
            border: 'solid rgba(255, 255, 255, 1)',
            borderWidth: '0 3px 3px 0',
          },
        },
      }
    },
  }
});

theme.MUITheme = MUITheme;

export default theme;



// WEBPACK FOOTER //
// ./src/settings/themes/rentalstep.js